// Version pattern for compound record versions (vYYYYMMDD). Ported from V1.
const versionPattern = /^v\d{8}$/;

/**
 * Validates both format and date for a version string.
 * Matches the backend implementation in compound_records/domain/types/version.ts.
 */
export function validateVersionFormat(value: string): boolean {
  if (!versionPattern.test(value)) return false;

  const datePart = value.substring(1);
  const year = Number.parseInt(datePart.substring(0, 4), 10);
  const month = Number.parseInt(datePart.substring(4, 6), 10);
  const day = Number.parseInt(datePart.substring(6, 8), 10);

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}
